module.exports = __webpack_public_path__ + "img/basic_wrinklegel_202311.605dada0.jpg";